import { render } from "./contapagar-editar.vue?vue&type=template&id=d7452128"
import script from "./contapagar-editar.vue?vue&type=script&lang=js"
export * from "./contapagar-editar.vue?vue&type=script&lang=js"

import "./contapagar-editar.vue?vue&type=style&index=0&id=d7452128&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__